export default __webpack_public_path__ + "static/media/AthletesHelp.ca535a40.pdf";